namespace TabAurous.Inventory {
@Serenity.Decorators.registerEditor()
export class RejectionTypeEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            // add option accepts a key (id) value and display text value
            this.addOption("1", "Stock");
            this.addOption("2", "POS Sales");
            this.addOption("3", "Sales");
            this.addOption("4", "Complete Repair");
        }
    }
}